import React from 'react';
import { ButtonsContainer, FormContainer } from '../../components/Layout';
import { Button, FieldsMapper, Spinner } from '../../components/Common';
import ModalContent from '../../components/Common/Modal/ModalContent';
import ModalTitle from '../../components/Common/Modal/ModalTitle';
import ModalHeader from '../../components/Common/Modal/ModalHeader';
import { modal, recipes } from '../../actions';
import { useDispatch } from 'react-redux';
import ItfApiForm from '../../components/Common/TrackedItfApiForm';
import { RecipeDescriptionDetails } from 'profilpol-types';
import { successNotification } from '../../actions/notifications';
import { ButtonType } from '../../components/Common/Button';
import ApiService from '../../services/api-service';
import { pathToObject } from '../../utils/path-to-object';
import { formOnTranslateString } from '../../utils/trans-form';
import RecipeDescriptionFieldsMapper from './RecipeDescriptionFieldsMapper';

interface Props {
  recipeId: string;
  id?: string;
}

const RecipeDescription = ({ recipeId, id }: Props) => {
  const dispatch = useDispatch();
  let itfForm: any;

  const setRef = (form: any) => {
    itfForm = form;
  };
  return (
    <ModalContent>
      <ModalHeader>
        <ModalTitle
          title={id ? 'recipe.edit_description' : 'recipe.new_description'}
        />
      </ModalHeader>
      <FormContainer>
        <ItfApiForm
          unsavedScope="modal"
          ref={setRef}
          formId="recipeDescriptionForm"
          schemaMayBeDynamic={true}
          schemaCacheEnabled={false}
          loadingInfoAboveContent
          loadingInfo={<Spinner overlay halfTransparent />}
          sendDelay={200}
          requiredIndicator="*"
          schemaFetcher={() =>
            ApiService.loadForm(
              id
                ? `recipe/form/update-description/${recipeId}/${id}`
                : `recipe/form/add-description/${recipeId}`
            )
          }
          sendFetcher={(formId: string, values: any) => {
            const parsed = pathToObject(values);
            parsed.recipeId = recipeId;

            const field = new FormData();
            for (const key in parsed) {
              if (
                key === 'image' &&
                values.image &&
                typeof values.image !== 'string'
              ) {
                field.append('image', parsed.image, parsed.image.name);
              } else field.append(key, JSON.stringify(parsed[key]));
            }

            return ApiService.sendForm(
              id ? `recipe/description/${id}` : 'recipe/description',
              field,
              id ? 'PATCH' : 'POST',
              null
            );
          }}
          submitButton={(loading: boolean) => (
            <ButtonsContainer>
              <Button
                disabled={loading}
                small
                type={ButtonType.Button}
                danger
                click={() => dispatch(modal.hideModal())}
                text={'application.cancel'}
              />
              <Button
                disabled={loading}
                small
                type={ButtonType.Submit}
                success
                text={'application.save'}
              />
            </ButtonsContainer>
          )}
          onRenderFullField={(
            field,
            errors,
            fieldHtmlId,
            currentValue,
            onChange,
            onFocus,
            onBlur
          ) =>
            RecipeDescriptionFieldsMapper(
              field,
              errors,
              fieldHtmlId,
              currentValue,
              onChange,
              onFocus,
              onBlur,
              recipeId
            )
          }
          onSavedSuccessfully={(data: RecipeDescriptionDetails) => {
            dispatch(
              successNotification(
                id ? 'recipe.description_updated' : 'recipe.description_created'
              )
            );
            if (id) {
              dispatch(recipes.updateRecipeDescription(data));
            } else {
              dispatch(recipes.addNewRecipeDescription(data));
            }
            dispatch(modal.hideModal());
          }}
          onTranslateString={formOnTranslateString}
        />
      </FormContainer>
    </ModalContent>
  );
};

export default RecipeDescription;
